export default "__VITE_ASSET__CSi89heE__"